/*
 * @Author: your name
 * @Date: 2021-05-25 09:39:01
 * @LastEditTime: 2021-05-25 11:17:48
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \VtpWechatUI\src\store\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    wechatWebToken: '',
    openid: ''
  },
  mutations: {
    refreshToken(state, token) {
      state.wechatWebToken = token
    },
    saveOpenid(state, openid) {
      state.openid = openid
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js